import { Component, HostListener, ElementRef } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-regulatory-service',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgClass, RouterLink, NgFor, NgStyle, NgIf],
  templateUrl: './regulatory-service.component.html',
  styleUrl: './regulatory-service.component.scss'
})
export class RegulatoryServiceComponent {
  regulatoryContent: any;

  // pdfbaseurl ="https://www.chemrobotics.com/agropat/assets/"
  isMenuOpen = false;
  head: any[] = [];
  pdfFiles: any[] = [];
  currentPage: string = 'service';
  currentUrl: string;
  constructor(private datasearch: DatasearchService, private elementRef: ElementRef) {
    this.currentUrl = window.location.href; // Get the current URL

  }
  imageBaseUrl = this.datasearch.ApiUrl + '/uploads/images/';

  ngOnInit() {
    this.fetchRegulatoryContent();
    this.getHeading();
    this.getPdf();
  }

  fetchRegulatoryContent() {
    this.datasearch.getRegulatoryservice().subscribe(
      (response: any) => {
        if (response.success) {
          let data = response.data;
          if (Array.isArray(data)) {
            this.regulatoryContent = data.map((item: any) => this.mapContentItem(item));
          } else if (data && typeof data === 'object') {
            this.regulatoryContent = [this.mapContentItem(data)];
          }
        } else {
          console.log('Failed to fetch regulatory content');
        }
      },
      (error) => {
        console.error('Error fetching regulatory content:', error);
      }
    );
  }

  private mapContentItem(item: any) {
    // Utility to replace non-breaking spaces with normal spaces to allow text wrapping
    const clearSpaces = (text: string) => {
      if (!text || typeof text !== 'string') return text;
      return text.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
    };

    // Normalizing dynamic keys from API (handling both snake_case and camelCase)
    const header_title = clearSpaces(item.headerTitle || item.header_title || item.title || item.name || 'Regulatory Service');
    const header_subtitle = clearSpaces(item.headerSubTitle || item.header_subtitle || item.subtitle || item.sub_title || '');
    const header_description = clearSpaces(item.headerDescription || item.header_description || item.description || item.content || '');
    const image = item.image || item.header_image || item.icon || '';

    // Handling Lists (Section 1 or lists)
    let lists: any[] = [];
    const sourceLists = item.section1 || item.lists || [];
    if (Array.isArray(sourceLists)) {
      lists = sourceLists.map((l: any) => ({
        title: clearSpaces(l.title || l.name || l.header || ''),
        keyWords: Array.isArray(l.keyWords || l.keypoints || l.items)
          ? (l.keyWords || l.keypoints || l.items).map((k: any) => (typeof k === 'string' ? clearSpaces(k) : k))
          : []
      }));
    }

    // Handling Body Content (Section 2 or body/sections)
    let body: any[] = [];
    const sections = [];
    if (item.section2) sections.push(item.section2);
    if (item.body) {
      if (Array.isArray(item.body)) sections.push(...item.body);
      else sections.push(item.body);
    }
    if (item.sections) {
      if (Array.isArray(item.sections)) sections.push(...item.sections);
      else sections.push(item.sections);
    }

    body = sections.map((s: any) => ({
      body_title: clearSpaces(s.bodyTitle || s.body_title || s.title || s.name || ''),
      body_description: clearSpaces(s.bodyDescription || s.body_description || s.description || s.content || ''),
      body_keypoints: Array.isArray(s.bodyPoints || s.body_keypoints || s.keypoints || s.points)
        ? (s.bodyPoints || s.body_keypoints || s.keypoints || s.points).map((p: any) => ({
          keypoints_title: clearSpaces(p.pointTitle || p.keypoints_title || p.title || ''),
          keypoints_description: clearSpaces(p.pointDescription || p.keypoints_description || p.description || ''),
          keypoints_icon: p.icon || p.keypoints_icon || p.image || ''
        }))
        : []
    }));

    // Ensure they are not empty for the template's index access
    if (lists.length === 0) lists.push({ title: '', keyWords: [] });
    if (body.length === 0) body.push({ body_title: '', body_description: '', body_keypoints: [] });

    return {
      ...item,
      header_title,
      header_subtitle,
      header_description,
      image,
      lists,
      body
    };
  }
  getPdf() {
    const baseUrl = this.datasearch.ApiUrl + '/uploads/brochures/';
    this.datasearch.getBrochure().subscribe(
      (response: any) => {
        if (response.success && Array.isArray(response.data)) {
          this.pdfFiles = response.data.map((pdf: any) => ({
            file_name: pdf.file_name, // Keep this consistent with the template
            url: baseUrl + (pdf.brochure || pdf.pdf || '') // Use 'brochure' field from API response
          }));
        } else {
          console.error('No brochure data found or response unsuccessful');
        }
      },
      (error) => {
        console.error('Error fetching brochures:', error);
      }
    );
  }

  // Function to extract a cleaner name from the filename
  getFormattedPdfName(fileName: string): string {
    return fileName.replace(/_/g, ' ').replace(/\.[^/.]+$/, '');
  }


  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isMenuOpen = false;
    }
  }
  getHeading() {
    this.datasearch.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
}
